import React, { Component } from 'react'
import { Button } from 'reactstrap';

export default class ReduxFormButton extends Component {
  render() {
    const {
      input: { value, onChange },
      text,
      icon,
      size,
      className,
      disabled
    } = this.props;

    return (
      <Button color="default" disabled={disabled} className={className + (value ? ' active' : '')} size={size} type="button" onClick={() => onChange(!value)}>{icon ? icon : text}</Button>
    )
  }
}